export default __webpack_public_path__ + "static/media/nochange.8c587c9a.png";